export default __webpack_public_path__ + "70fec1371dd2c297d98b896d16cfbe4b.png";